/*
 * @Author: Phoenix
 * @Date: 2020-03-27 11:54:43
 * @LastEditTime: 2020-03-27 11:57:30
 * @Description:
 * @FilePath: /ups-single-window-web/src/router/roles.js
 * @未经本人许可，任何单位及个人不得以任何方式对本产品进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。
 */

const roleAdmin = 'Admin'
const roleOperator = 'Operator'
const roleCustomer = 'Customer'

export default {
  roleAdmin,
  roleOperator,
  roleCustomer
}
